const messages = {
  title: "CJENOVNICI I BROŠURE PROIZVODA",
  description:
    "Preuzmite najnovije brošure i letke o našim Bridgestone i Firestone gumama za putnička vozila, SUV-ove i kombije ovdje.",
  brochureCategories: {
    products: "Proizvodi",
    brand_and_solutions: "Brend i rješenja",
    season_and_promotions: "Sezona i promocije",
    format: "Format",
    cars_and_vans: "Putničko vozilo i kombi",
    summer: "Ljeto",
    winter: "Zima",
    promotions: "Promocije",
    all_season: "Sve sezone",
    truck_and_buses: "Kamioni i autobusi",
    motorcycle: "Motocikl",
    agriculture: "Poljoprivreda",
    construction_machinery: "Građevinska mašinerija",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materijali",
    brochures: "Brošure proizvoda",
    price_list: "Cjenovnici",
    materials: "Materijali",
    video_in_store: "Video s titlovima",
    video_online: "Video bez titlova",
    banner_website: "Banner",
    banner_social_media: "Društvene mreže",
    logos: "Logoi",
  },
  searchMedia: "Unesite ključnu riječ",
  searchResults: "Rezultati pretrage",
};

export default {
  messages,
};
